import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {browserHistory} from 'react-router';
import {takeLatest, select, take, call} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import gql from 'graphql-tag';

import {selectEnv} from 'reducers/env';
import {signAllocationSaga} from 'api/allocations';

const namespace = 'flows/invest/agreement';

export const Qoperation = 'InvestAgreementInfo';
export const query = gql`
query ${Qoperation} ($allocationId: ID!) {
  allocation(id: $allocationId) {
    id
    self
    investment {
      funded
      allocated
    }
    deal {
      id
      name
      series {
        name
      }
      asset {
        name
      }
      sponsor {
        name
      }
    }
    syndicate {
      name
    }
  }
}
`;

export const Moperation = 'SignDocs';
export const mutation = gql`
  mutation ${Moperation}($allocationId: ID!) {
    allocation: sign_docs(id: $allocationId) {
      id
      documents {
        signed
      }
    }
  }
`;
export const signProps = ({mutate, ownProps}) => () => mutate({
  variables: {
    allocationId: ownProps.params.allocationId,
  },
});

// Actions
const SIGNED_INVEST_AGREEMENT = defineAction('SIGNED_INVEST_AGREEMENT', namespace);

export const signedInvestAgreement = createAction(SIGNED_INVEST_AGREEMENT.ACTION);

// Invest Agreement Saga
export function* signedInvestAgreementSaga({payload}) {
  const {allocation, id, after, confirmationToast} = payload;

  const env = yield select(selectEnv);

  if (env.web) {
    // Show toast
    if(confirmationToast === "yes") {
      const message = `Closing docs for ${allocation.deal.name} signed`;
      yield call([toast, toast.success], message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }

    // Take them to the next page
    yield call(browserHistory.push, atob(after));
  }
}

export function* sagas() {
  yield takeLatest(SIGNED_INVEST_AGREEMENT.ACTION, signedInvestAgreementSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/invest/agree/index.js